import styles from "../Report1.module.css";

export default function Report1({ goHome }) {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.logo}>
            <h1>U.S. NAVAL AERO</h1>
          </div>

          <div>
            <h2>Field Maintenance Ledger — FA/18 Service Section</h2>
            <p className={styles.lead}>
            </p>
          </div>

          <div className={styles.headerRight}>
            <div className={styles.stamp}>CLASSIFIED — TECH ONLY</div>
            <div className={styles.form}>Form: TER-18-2015</div>
          </div>
        </header>

        <section className={styles.reports}>
          <article className={styles.report}>
            <div className={styles.meta}>
              <div className={styles.metaLeft}>
                <strong>Service Report:</strong> FA/18 — BuNo 94512
                <div className={styles.metaSub}>
                  Date: June 12, 2015 | Location: NAS Corpus Christi — Flight Line
                  B
                </div>
              </div>

              <div className={styles.metaRight}>
                Techs: J. H. Miller (A&SM 1st Class)
                <br />
                Shift: Night
              </div>
            </div>

            <h3>Engine Run — Post-Landing Inspection</h3>

            <table className={styles.log}>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Observation</th>
                  <th>Action Taken</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>#1 Compressor Rotor</td>
                  <td>
                    Minor nicks visible on leading edge; no foreign object found.
                  </td>
                  <td>
                    Light dressing applied; torque check performed. Acceptable
                    for local ferry.
                  </td>
                </tr>
                <tr>
                  <td>Fuel System</td>
                  <td>Slow pressure decay noted during ground idle.</td>
                  <td>
                    Replaced fuel line coupling P/N: F-12-3. Pressure stabilized
                    to spec (28 ±2 psi).
                  </td>
                </tr>
                <tr>
                  <td>Oil Cooler</td>
                  <td>Trace seep at lower flange.</td>
                  <td>
                    Retorqued clamp to 22 ft-lb. Reinspect after 5 engine cycles.
                  </td>
                </tr>
              </tbody>
            </table>

            <div className={styles.note}>
              Remarks: Believe source of seep is minor gasket seating issue —
              order gasket kit (GKT-56) to depot. Aircraft cleared for non-combat
              transit to NAS Corpus Christi depot at pilot request.
            </div>

            <div className={styles.sig}>
              <div>
                <span className={styles.signature}>J. H. Miller</span>
                <div className={styles.initials}>
                  A&SM 1st Class — 7th Airframe Shop
                </div>
              </div>

              <div className={styles.inspector}>
                <div>Inspector:</div>
                <div className={styles.scribble}>R. T. Beaumont</div>
                <div className={styles.inspectorSub}>
                  (Maintenance Officer — Night Watch)
                </div>
              </div>
            </div>
          </article>
        </section>

        <footer className={styles.footer}>
          <button onClick={goHome}>← Back to Home</button>
        </footer>
      </div>
    </div>
  );
}
